// extracted by mini-css-extract-plugin
export default {"container":"container_F6zVq","pagination":"pagination_iCOPr"};